import api from "./apiConfig";

export const CREATE_RECURSO = async (data) => {
	try {
		const response = await api.post("/taxResources", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_RECURSO_BY_CASO = async (id) => {
	try {
		const response = await api.get(`/taxResourcesByTaxMatterId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_RECURSO = async (id, data) => {
	try {
		const response = await api.put(`/taxResources/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};